import { render } from "./AuthFormLink.vue?vue&type=template&id=88b4fc32&scoped=true&ts=true"
import script from "./AuthFormLink.vue?vue&type=script&lang=ts"
export * from "./AuthFormLink.vue?vue&type=script&lang=ts"

import "./AuthFormLink.vue?vue&type=style&index=0&id=88b4fc32&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b4fc32"]])

export default __exports__